module.exports = __webpack_public_path__ + "img/copied_icon.fdd3d17e.svg";